import React, { useState } from 'react';
import axios from 'axios';
import * as Routes from 'modules/routes';
import Modal from '@/components/ui/Modal';
import SubmitFooter from '@/components/ui/Modal/SubmitFooter';

type UnitNumberModalProps = {
  close: () => void;
  isOpen: boolean;
  unitTitle?: string;
  unitNumber?: number;
  unitProgramLessonId?: number;
};

type InputType = {
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
  name?: string;
};

const Input = ({ onChange, placeholder, name, label, disabled = false } : InputType) => (
  <label className="tw-flex tw-gap-x-2 tw-mb-4 tw-items-center">
    {label}:
    <input
      disabled={disabled}
      name={name}
      placeholder={placeholder}
      onChange={e => onChange(e)}
    />
  </label>
);

const UnitNumberModal = ({ close, isOpen, unitTitle, unitNumber, unitProgramLessonId }: UnitNumberModalProps) => {
  const [unitNumberForm, setUnitNumberForm] = useState({ name: unitTitle, number: unitNumber?.toString() || null });

  const isValid = (value: string) => {
    const number = parseInt(value, 10);
    if (number === undefined || number === null) return false;
    if (Number.isNaN(number)) return false;
    return number >= 0;
  };

  const handleSubmit = async () => {
    if (!isValid(unitNumberForm.number)) return;
    const path = Routes.plato_api_program_lesson_path(unitProgramLessonId);
    await axios.patch(path, { program_lesson: { title_number: unitNumberForm.number } })
      .then(() => { window.location.reload(); });
  };

  const handleChange = (e) => {
    setUnitNumberForm({
      ...unitNumberForm,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal close={close} headerText="Edit Unit Number" isOpen={isOpen}>
      <form onSubmit={(e) => { e.preventDefault(); }}>
        <Input disabled label="Title" name="name" placeholder={unitTitle} onChange={handleChange} />
        <Input label="Unit Number" name="number" placeholder={unitNumber?.toString()} onChange={handleChange} />
        <SubmitFooter isValid close={close} onSubmit={handleSubmit} />
      </form>
    </Modal>
  );
};
export default UnitNumberModal;
